import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143b20e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "terms-page-container" }
const _hoisted_2 = { class: "terms-header" }
const _hoisted_3 = { class: "terms-contents-wrapper" }
const _hoisted_4 = { class: "terms-title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "terms-footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Image, {
        src: "svg/logo",
        extension: "svg"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.termsTitle), 1),
      _createElementVNode("div", {
        class: "terms-contents",
        innerHTML: _ctx.terms
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6
  ]))
}